<template>
  <button :class="`btn ${btnClass} text-white btn-icon-only rounded-circle mt-1`">
    <i :class="icon"></i>
  </button>
</template>

<script>
export default {
  name: "icon-button",
  props: {
    icon: String,
    btnClass: {
      type: String,
      default: "btn-primary"
    }
  }
};
</script>